import { useTranslation } from "react-i18next";
import { Label } from "semantic-ui-react";


export const STATUS_MAP = {
    DRAFT: {color:'grey'} ,
    ENABLED: {color:'blue'} ,
    DISABLED: {color:'grey', basic:true },
    COMPLETED: {color:'green'} ,
}

export const STATUS_ARRAY = Object.keys(STATUS_MAP).reduce((acc, status) => {
    acc.push({key:status,label:{...STATUS_MAP[status]}});
    return acc;
}, []);







export const PromotionCampaignStatusLabel = ({status, ...labelProps}) => {
    const { t } = useTranslation();
    return <Label {...STATUS_MAP[status]} {...labelProps} content={t(`promotion_campaign.status.${status}`, status)} /> ;
}
